import api from "@/api/api-v2-config";

//#region Employee

export async function getEmployeeAxios() {    
    return await api.get("hrms/employee?PageNumber=1&PageSize=10000");
}

export async function deleteEmployeeAxios(id) {    
    return await api.delete("hrms/employee/" + id);
}

export async function postEmployeeAxios(item) {    
    return await api.post("hrms/employee", item);
}

export async function putEmployeeAxios(item) {    
    return await api.put("hrms/employee", item);
}

export async function getEmployeeByIdAxios(id) {
    return await api.get(`hrms/employee/${id}`);
}

//#endregion

//#region Document

export async function getEmployeeDocAxios() {    
    return await api.get("hrms/employeedocument");
}
export async function getEmployeeIdDocAxios(id) {    
    console.log("🚀 ~ getEmployeeIdDocAxios ~ id:", id)
    return await api.get("hrms/employeedocument?EmployeeId=" + id);
}

export async function deleteEmployeeDocAxios(id) {    
    return await api.delete("hrms/employeedocument/" + id);
}

export async function postEmployeeDocAxios(item) {    
    return await api.post("hrms/employeedocumentupload", item);
}

export async function putEmployeeDocAxios(item) {    
    return await api.put("hrms/employeedocument", item);
}

export async function getEmployeeDocByIdAxios(employeeId, id) {
    return await api.get(`hrms/employeedocument/${employeeId}/${id}`);
}

export async function downloadEmployeeDocAxios(id) {
    return await api.get(`hrms/employeedocument/${id}`,{ responseType: 'blob' });
}

//#endregion
